import * as actionTypes from "./actionTypes";

export const setExceptionReporting = (exceptionReportConf) => {
  return {
    type: actionTypes.SET_EXCEPTION_REPORT,
    exceptionReportConf,
  };
};

export const unsetExceptionReporting = () => {
  return {
    type: actionTypes.UNSET_EXCEPTION_REPORT,
  };
};

export const showExceptionReporting = (dispatch, requestId) => {
  dispatch(
    setExceptionReporting({
      requestId,
      dismiss: () => {
        dispatch(unsetExceptionReporting());
      },
    }),
  );
};
